import { Icon, IconProps } from "@chakra-ui/react";

const Register = (props: IconProps & any) => (
  <Icon boxSize="8" viewBox="0 0 128 128" {...props}>
    <rect
      x={68.219}
      y={33.477}
      width={33.75}
      height={28.125}
      rx={4}
      stroke="currentColor"
      strokeWidth={4}
      fillOpacity={0}
    />
    <path
      stroke="currentColor"
      strokeWidth={4}
      strokeLinecap="round"
      d="M75.141 39.914h19.906M75.141 46.945h19.906M75.141 53.977h19.906"
    />
    <rect
      x={26.031}
      y={33.477}
      width={33.75}
      height={28.125}
      rx={4}
      stroke="currentColor"
      strokeWidth={4}
      fillOpacity={0}
    />
    <path
      stroke="currentColor"
      strokeWidth={4}
      strokeLinecap="round"
      d="M32.953 39.914h19.906M32.953 46.945h19.906M32.953 53.977h19.906"
    />
    <rect
      x={16}
      y={26.102}
      width={96}
      height={42.875}
      rx={2}
      stroke="currentColor"
      strokeWidth={4}
      fillOpacity={0}
    />
    <path
      d="M41.781 77.227a2 2 0 1 0-4 0h4Zm4.284 25.493 1.696 1.06-1.696-1.06Zm-.848 0-1.696 1.06 1.696-1.06Zm-3.005-4.807-1.696 1.06 1.697-1.06Zm-4.43-20.686v7.226h4v-7.226h-4Zm5.859 13.085v6.836h4v-6.835h-4Zm2 8.836h3.004v-4H45.64v4Zm1.732-2.295-3.004 4.807 3.392 2.12 3.004-4.807-3.392-2.12Zm-.46 4.807-3.005-4.807-3.392 2.12 3.005 4.807 3.392-2.12Zm-4.276-2.512h3.004v-4h-3.005v4Zm1.732 2.512a1.5 1.5 0 0 1 2.544 0l-3.392 2.12c.979 1.567 3.26 1.567 4.24 0l-3.392-2.12Zm4.276-2.512a1.5 1.5 0 0 1-1.272-2.295l3.392 2.12c1.04-1.665-.157-3.825-2.12-3.825v4Zm-5.934-9.765a.93.93 0 0 1 .93.93h4a4.93 4.93 0 0 0-4.93-4.93v4Zm1.197 7.47a1.5 1.5 0 0 1-1.272 2.295v-4c-1.963 0-3.16 2.16-2.12 3.825l3.392-2.12Zm-6.127-12.4a4.93 4.93 0 0 0 4.93 4.93v-4a.93.93 0 0 1-.93-.93h-4ZM61.313 77.227a2 2 0 1 0-4 0h4Zm4.283 25.493 1.696 1.06-1.696-1.06Zm-.848 0-1.696 1.06 1.696-1.06Zm-3.004-4.807-1.696 1.06 1.696-1.06Zm-4.431-20.686v7.226h4v-7.226h-4Zm5.859 13.085v6.836h4v-6.835h-4Zm2 8.836h3.004v-4h-3.004v4Zm1.732-2.295L63.9 101.66l3.392 2.12 3.004-4.807-3.392-2.12Zm-.46 4.807-3.004-4.807-3.392 2.12 3.004 4.807 3.392-2.12Zm-4.276-2.512h3.004v-4h-3.004v4Zm1.732 2.512a1.5 1.5 0 0 1 2.544 0l-3.392 2.12c.979 1.567 3.26 1.567 4.24 0l-3.392-2.12Zm4.276-2.512a1.5 1.5 0 0 1-1.272-2.295l3.392 2.12c1.04-1.665-.156-3.825-2.12-3.825v4Zm-5.934-9.765a.93.93 0 0 1 .93.93h4a4.93 4.93 0 0 0-4.93-4.93v4Zm1.198 7.47a1.5 1.5 0 0 1-1.272 2.295v-4c-1.964 0-3.16 2.16-2.12 3.825l3.392-2.12Zm-6.127-12.4a4.93 4.93 0 0 0 4.93 4.93v-4a.93.93 0 0 1-.93-.93h-4ZM80.844 77.227a2 2 0 0 0-4 0h4Zm4.283 25.493 1.696 1.06-1.696-1.06Zm-.848 0-1.696 1.06 1.696-1.06Zm-3.004-4.807-1.696 1.06 1.696-1.06Zm-4.431-20.686v7.226h4v-7.226h-4Zm5.86 13.085v6.836h4v-6.835h-4Zm2 8.836h3.003v-4h-3.004v4Zm1.731-2.295-3.004 4.807 3.392 2.12 3.004-4.807-3.392-2.12Zm-.46 4.807-3.004-4.807-3.392 2.12 3.004 4.807 3.392-2.12ZM81.7 99.148h3.004v-4H81.7v4Zm1.732 2.512a1.5 1.5 0 0 1 2.544 0l-3.392 2.12c.98 1.567 3.261 1.567 4.24 0l-3.392-2.12Zm4.276-2.512a1.5 1.5 0 0 1-1.272-2.295l3.392 2.12c1.04-1.665-.156-3.825-2.12-3.825v4Zm-5.934-9.765a.93.93 0 0 1 .93.93h4a4.93 4.93 0 0 0-4.93-4.93v4Zm1.198 7.47a1.5 1.5 0 0 1-1.272 2.295v-4c-1.964 0-3.16 2.16-2.12 3.825l3.392-2.12Zm-6.127-12.4a4.93 4.93 0 0 0 4.93 4.93v-4a.93.93 0 0 1-.93-.93h-4Z"
      fill="currentColor"
    />
  </Icon>
);

export default Register;
